export const API_JWT_ACCESS_URL = "https://sso.trueshape.sg/sso/api/token/"; //JWT access token API
export const API_JWT_REFRESH_URL =
  "https://sso.trueshape.sg/sso/api/token/refresh/"; //JWT refresh token API
export const API_JWT_BOOTSTRAP_URL =
  "https://sso.trueshape.sg/sso/api/token/bootstrap/"; //JWT bootstrap token API
export const API_LOGOUT_URL = "https://sso.trueshape.sg/sso/api/logout/";
export const API_SSO_USER_URL = "https://sso.trueshape.sg/user/"; //JWT access token API
export const API_SSO_ALL_USER_URL = "https://sso.trueshape.sg/user/all/"; //SSO User All API
export const API_UPDATE_USER_URL = "https://sso.trueshape.sg/user/update/"; //Update SSO User API
export const API_CREATE_USER_URL = "https://sso.trueshape.sg/user/signup/"; //SSO User API
export const API_FORGOT_PASSWORD_URL =
  "https://sso.trueshape.sg/user/reset-password-request/"; //Forgot Password API
// export const API_RESET_PASSWORD_URL =
//   'https://sso.trueshape.sg/user/reset-password/'; //Forgot Password API
export const API_COUNTRY_URL = "https://sso.trueshape.sg/user/countries/"; //List all country list API
export const API_BRANCH_URL = "https://sso.trueshape.sg/organization/branch/"; //Branch API
export const API_SERVICE_URL = "https://sso.trueshape.sg/sso/service/all/"; //Service API
export const API_CONNECTION_URL =
  "https://sso.trueshape.sg/sso/connection/new/"; //Connection API
export const API_ORGANIZATION_CMS_URL =
  "https://tscms.trueshape.sg/organization/all/"; //Organization API
export const API_PACKAGES_URL = "https://tscms.trueshape.sg/cms/packages/"; //Packages API
export const API_PACKAGESTATUS_URL =
  "https://tscms.trueshape.sg/cms/packagestatus/"; //Package Status API
export const API_PACKAGEUSAGES_URL =
  "https://tscms.trueshape.sg/cms/packageusages/"; //Package Usages API
export const API_CART_URL = "https://tscms.trueshape.sg/cms/carts/"; //Cart API
export const API_CREATECART_URL = "https://tscms.trueshape.sg/cms/createcarts/"; //Create Cart API
export const API_CHECKOUT_URL = "https://tscms.trueshape.sg/cms/checkouts/"; //Treatment API
export const API_CREATECHECKOUT_URL =
  "https://tscms.trueshape.sg/cms/createcheckouts/"; //Checkout API
export const API_PAYMENT_URL = "https://tscms.trueshape.sg/cms/payment/"; //Payment API
export const API_CUSTOMER_URL = "https://tscms.trueshape.sg/cms/customers/"; //Customer API
export const API_TREATMENT_URL = "https://tscms.trueshape.sg/cms/treatment/"; //Treatment API
export const API_ITEM_URL = "https://tscms.trueshape.sg/cms/items/"; //Item API
export const API_ITEMPURCHASE_URL =
  "https://tscms.trueshape.sg/cms/itempurchases/"; //Item Purchase API
export const API_CATALOG_URL = "https://tscms.trueshape.sg/cms/catalogs/"; //catalog API
export const API_CREATECATALOG_URL =
  "https://tscms.trueshape.sg/cms/createcatalogs/"; //create catalog API
export const API_PAYMENTFEE_URL = "https://tscms.trueshape.sg/cms/paymentfee/"; //Payment Fee API
export const API_KEYFIELD_URL = "https://tscms.trueshape.sg/cms/keyfields/"; //Reference Types API
export const API_KEYOBJECT_URL = "https://tscms.trueshape.sg/cms/keyobjects/"; //Reference Types API
export const API_REFTYPE_URL = "https://tscms.trueshape.sg/cms/reftypes/"; //Reference Types API
export const API_DROPDOWNOPTION_URL =
  "https://tscms.trueshape.sg/cms/dropdownoptions/"; //Dropdown Options API
export const API_USER_URL = "https://tscms.trueshape.sg/user/"; //Users API
export const API_ALL_USER_URL = "https://tscms.trueshape.sg/user/all/"; //All Users API
export const API_USER_GROUP_URL = "https://tscms.trueshape.sg/user/groups/"; //User Group API
export const API_PAYMENT_REQUEST =
  "https://tscms.trueshape.sg/cms/payment-request/"; //Hitpay payment request
export const API_AUDIT_LOG_URL =
  "https://tscms.trueshape.sg/audit/cms/audit-logs/"; //Audit Log API
export const API_AUDIT_CONFIG_URL =
  "https://tscms.trueshape.sg/audit/cms/audit-config/"; //Audit Config API
export const TIMEOUT_SEC = 30; //API timeout setting
export const MODAL_TIMEOUT_SEC = 1; //API timeout setting
